export default "__VITE_ASSET__BmMdHk9O__"